import { Container } from '@mui/material';
import React from 'react'
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';
import { NavMainContainer } from './styles';

const LockerMenu = (props) => {
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
        {
        title: "Home",
        link: "#home",
        },
        {
        title: "Tokenomics",
        link: "#tokenomics",
        },
    ];
  return (
    <NavMainContainer maxWidth="xl">
        <DesktopMenu menuList={menuList} />
        <MobileMenu menuList={menuList} />
    </NavMainContainer>
  )
}

export default LockerMenu